import {rocketSvg as Icon__small__rocketSvg} from '../Icon__small/Icon__small--rocket.js';

export var rocket = {
  name: 'rocket',
  category: 'icon',
  colorable: true,
  svg: Icon__small__rocketSvg,
};
